import React from "react";
import { useApp } from "@/context/AppContext";
import { resolveMediaUrl } from "@/components/FileUpload";

export const YalolaLogo = ({ size = 40 }) => {
  let logoUrl = "";
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { config } = useApp();
    logoUrl = config?.settings?.brand?.logo_url || "";
  } catch { /* outside provider: fall back to default brand mark */ }

  const src = logoUrl ? resolveMediaUrl(logoUrl) : "/yalola-logo.png";

  return (
    <img
      src={src}
      alt="Yalola"
      className="rounded-2xl object-cover shrink-0"
      style={{ width: size, height: size }}
      data-testid="app-logo-img"
    />
  );
};
